import React from "react";
import styled from "styled-components";
import "./MacbookPage.css";

export const theme = {
  colors: {
    background: "#000000",
    text: "#FFFFFF",
    textSecondary: "#808080",
    primary: "#404040",
  },
  breakpoints: {
    mobile: "320px",
    tablet: "768px",
    desktop: "1024px",
  },
};

const MacbookPage = () => {
  return (
    <div>
      <Container>
        <ImageSection>
          <div className="desktop-mockup">
            <iframe
              src="home-screen-satullia-desktop.html"
              title="Macbook UI"
              className="desktop-webapp-iframe"
            ></iframe>
          </div>
        </ImageSection>
        <ContentSection>
          <Title
            onClick={() =>
              window.open("https://satullia.codemagic.app", "_blank")
            }
          >
            Satullia
          </Title>
          <Description>A purpose-driven social platform.</Description>
          <Feature>
            <a
              href="https://satullia.codemagic.app"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "inherit", textDecoration: "none" }}
            >
              🚀 Try Satullia
            </a>
          </Feature>
          <FeatureList>
            <Feature>✦ Personalized recommendations</Feature>
            <Feature>✦ Interest-based groups</Feature>
            <Feature>✦ Achievement system</Feature>
          </FeatureList>
        </ContentSection>
      </Container>
      {/* <hr style={{ margin: "8rem 0" }} /> 
      <Container>
        <ContentSection>
          <Title
            onClick={() =>
              window.open("https://topbeat.danials.space/", "_blank")
            }
          >
            Topbeat
          </Title>
          <Description>Discover your top song and artist</Description>
          <Feature>
            <a
              href="https://topbeat.danials.space/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "inherit", textDecoration: "none" }}
            >
              🚀 Try Topbeat
            </a>
          </Feature>
          <FeatureList>
            <Feature>✦ Connect your Spotify account</Feature>
            <Feature>✦ See your most-played track</Feature>
            <Feature>✦ Share your music taste</Feature>
          </FeatureList>
        </ContentSection>
        <ImageSection>
          <div className="phone-mockup">
            <iframe
              src="home-screen-topbeat.html"
              title="Web App"
              className="desktop-webapp-iframe"
            ></iframe>
          </div>
        </ImageSection>
      </Container> */}
    </div>
  );
};

const Container = styled.div`
  display: flex;
  height: 90%;
  background-color: ${theme.colors.background};
  padding: 1rem 8rem;
  @media (max-width: ${theme.breakpoints.tablet}) {
    flex-direction: column;
  }
  @media (max-width: 768px) {
    padding: 1rem 1rem;
  }
`;

const ContentSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2rem;
`;

const Title = styled.h1`
  font-size: 5rem;
  color: ${theme.colors.text};
  // margin-bottom: 1rem;
`;

const Description = styled.p`
  font-size: 1.2rem;
  color: ${theme.colors.textSecondary};
  max-width: 37.5rem;
  line-height: 1.6;
`;
const ImageSection = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 1024px) {
    display: none;
  }
`;
const FeatureList = styled.div`
  list-style: none;
  padding: 0;
  margin: 2rem 0;
  color: ${theme.colors.text};
  display: flex;
  flex-direction: column;
`;

const Feature = styled.div`
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
`;

export default MacbookPage;
